export const GET_LANGUAGE_ALL = {
    PENDING: 'GET_LANGUAGE_ALL_PENDING',
    FULFILLED: 'GET_LANGUAGE_ALL_FULFILLED',
    REJECTED: 'GET_LANGUAGE_ALL_REJECTED'
};
